// Aviso "Gravando" para todos na reunião e, para o administrador do escritório, o botão de gravar (0.45).
import { useEffect, useState } from 'react';
import { ActivityIndicator, Pressable, Text, View } from 'react-native';
import { useGravacao } from '../lib/gravacao';
import { t } from '../lib/i18n';

const pilula = { flexDirection: 'row' as const, alignItems: 'center' as const, gap: 6, paddingHorizontal: 12, paddingVertical: 7, borderRadius: 18 };

export function GravarReuniao({ conversa, room }: { conversa: string; room: any }) {
  const g = useGravacao(conversa, room);
  const [menu, setMenu] = useState(false);
  const [, tique] = useState(0);
  useEffect(() => { if (!g.minha) return; const i = setInterval(() => tique(x => x + 1), 1000); return () => clearInterval(i); }, [g.minha]);
  if (!g.pode && !g.gravando) return null;
  const seg = g.minha ? Math.floor((Date.now() - g.minha.desde) / 1000) : 0;
  const mm = `${String(Math.floor(seg / 60)).padStart(2, '0')}:${String(seg % 60).padStart(2, '0')}`;
  return (
    <View style={{ alignItems: 'center', gap: 6, paddingVertical: 4 }}>
      <View style={{ flexDirection: 'row', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
        {g.gravando && (
          <View style={[pilula, { backgroundColor: 'rgba(220,38,38,0.9)' }]}>
            <Text style={{ color: '#fff', fontWeight: '800', fontSize: 12 }}>⏺ {t('Gravando')}{g.minha ? ` · ${mm}${g.minha.parte > 1 ? ' · ' + t('parte {n}', { n: g.minha.parte }) : ''}` : ''}</Text>
          </View>
        )}
        {g.pode && (g.ocupado ? <ActivityIndicator color="#fff" /> : g.minha ? (
          <Pressable onPress={g.parar} style={[pilula, { backgroundColor: 'rgba(255,255,255,0.18)' }]}>
            <Text style={{ color: '#fff', fontWeight: '700', fontSize: 12 }}>⏹ {t('Parar gravação')}</Text>
          </Pressable>
        ) : !g.gravando && (
          <Pressable onPress={() => setMenu(!menu)} style={[pilula, { backgroundColor: 'rgba(255,255,255,0.18)' }]}>
            <Text style={{ color: '#fff', fontWeight: '700', fontSize: 12 }}>⏺ {t('Gravar reunião')}</Text>
          </Pressable>
        ))}
      </View>
      {menu && !g.minha && (
        <View style={{ backgroundColor: 'rgba(17,24,39,0.96)', borderRadius: 14, padding: 10, gap: 8, maxWidth: 320 }}>
          <Text style={{ color: '#D1D5DB', fontSize: 12 }}>{t('Todos na reunião veem o aviso "Gravando". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.')}</Text>
          <View style={{ flexDirection: 'row', gap: 8, justifyContent: 'center' }}>
            <Pressable onPress={() => { setMenu(false); g.iniciar('video'); }} style={[pilula, { backgroundColor: '#DC2626' }]}>
              <Text style={{ color: '#fff', fontWeight: '700' }}>🎥 {t('Vídeo')}</Text></Pressable>
            <Pressable onPress={() => { setMenu(false); g.iniciar('audio'); }} style={[pilula, { backgroundColor: '#374151' }]}>
              <Text style={{ color: '#fff', fontWeight: '700' }}>🎙️ {t('Só áudio')}</Text></Pressable>
          </View>
        </View>
      )}
      {!!g.erro && (
        <Pressable onPress={g.limparErro} style={{ backgroundColor: 'rgba(127,29,29,0.95)', borderRadius: 12, padding: 10, maxWidth: 340 }}>
          <Text style={{ color: '#fff', fontSize: 12 }}>{g.erro}</Text>
        </Pressable>
      )}
    </View>
  );
}
